import { createSlice } from "@reduxjs/toolkit";
import { setCurrentAccount } from "../current-account/current-account";
var initialState = {
    accountId: undefined,
    accountSecret: undefined,
    bypassAuthentication: Boolean(import.meta.env.VITE_BYPASS_AUTH)
};
export var authMiddleware = function(store) {
    return function(next) {
        return function(action) {
            if (authSlice.actions.setAccountId.match(action)) {
                if (action.payload) {
                    var accounts = store.getState().accounts.accounts;
                    var account = accounts.find(function(param) {
                        var key = param.key;
                        return key === action.payload;
                    });
                    if (account) {
                        var currentAccountId = store.getState().auth.accountId;
                        // Reset usage state immediately if current api_key changed
                        if (currentAccountId && currentAccountId !== account.key) {
                            store.dispatch(setCurrentAccount({
                                usage: {
                                    instances: 0,
                                    workspaces: 0
                                }
                            }));
                        }
                        store.dispatch(setAccountSecret(account.secret));
                        localStorage.setItem("vch.account_id", action.payload);
                    } else if (accounts.length > 0) {
                        action.payload = accounts[0].key;
                        store.dispatch(setAccountSecret(accounts[0].secret));
                        localStorage.setItem("vch.account_id", accounts[0].key);
                    } else {
                        localStorage.setItem("vch.account_id", action.payload);
                    }
                } else {
                    localStorage.removeItem("vch.account_id");
                }
            }
            return next(action);
        };
    };
};
var authSlice = createSlice({
    initialState: initialState,
    name: "auth",
    reducers: {
        setAccountId: function(state, param) {
            var payload = param.payload;
            state.accountId = payload;
        },
        setAccountSecret: function(state, param) {
            var payload = param.payload;
            state.accountSecret = payload;
        },
        setBypassAuthentication: function(state, param) {
            var payload = param.payload;
            state.bypassAuthentication = payload;
        }
    }
});
var _authSlice_actions = authSlice.actions;
export var setAccountId = _authSlice_actions.setAccountId, setAccountSecret = _authSlice_actions.setAccountSecret, setBypassAuthentication = _authSlice_actions.setBypassAuthentication;
export var authReducer = authSlice.reducer;

//# sourceMappingURL=auth.js.map